import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem } from '@shared/components/navigation/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const WalletsBreadcrumb = () => {
  const { t } = useTranslation('walletsModule');

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    return [
      {
        label: t('title', 'Billeteras'),
        title: t('title', 'Billeteras'),
      },
    ];
  }, [t]);

  usePageNavigation({ breadcrumbs });

  return null;
};
